import { render, staticRenderFns } from "./LobbyScreen.vue?vue&type=template&id=f2af6b8c&scoped=true&"
import script from "./LobbyScreen.vue?vue&type=script&lang=js&"
export * from "./LobbyScreen.vue?vue&type=script&lang=js&"
import style0 from "./LobbyScreen.vue?vue&type=style&index=0&id=f2af6b8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2af6b8c",
  null
  
)

export default component.exports